/* Modulo FAQ — accordion with smooth height transition + single/multi-open modes.
   Vanilla IIFE, lazy-init via window.moduloLazyInit when available. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  function initSection(el) {
    if (el.dataset.faqBound === '1') return;
    el.dataset.faqBound = '1';

    var mode  = el.getAttribute('data-mode') === 'multi' ? 'multi' : 'single';
    var items = el.querySelectorAll('[data-modulo-faq-item]');

    function close(item) {
      var content = item.querySelector('[data-modulo-faq-content]');
      var trigger = item.querySelector('[data-modulo-faq-trigger]');
      item.classList.remove('modulo-faq__item--open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (content) content.style.maxHeight = '0';
    }

    function open(item) {
      var content = item.querySelector('[data-modulo-faq-content]');
      var trigger = item.querySelector('[data-modulo-faq-trigger]');
      item.classList.add('modulo-faq__item--open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (content) content.style.maxHeight = content.scrollHeight + 'px';
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-modulo-faq-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('modulo-faq__item--open');

        if (mode === 'single' && !isOpen) {
          // close everything else first
          items.forEach(function (other) { if (other !== item) close(other); });
        }

        if (isOpen) close(item);
        else        open(item);
      });
    });

    // Recalc max-height on resize so wrapped answers don't get clipped.
    var resizeTimeout = null;
    window.addEventListener('resize', function () {
      if (resizeTimeout) clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        items.forEach(function (item) {
          if (!item.classList.contains('modulo-faq__item--open')) return;
          // An item inside a hidden tab panel measures scrollHeight 0, which would
          // pin maxHeight to 0 and leave it visually collapsed but still flagged
          // open the next time that tab is shown. Skip anything not laid out.
          if (item.offsetParent === null) return;
          var content = item.querySelector('[data-modulo-faq-content]');
          if (content) content.style.maxHeight = content.scrollHeight + 'px';
        });
      }, 100);
    }, { passive: true });

    initTabs(el);
  }

  // ── Topic tabs. Only present when the merchant made a Topic the first block;
  // with no Topic blocks this is a no-op and the section behaves exactly as before.
  function initTabs(el) {
    var tabs = Array.prototype.slice.call(el.querySelectorAll('[data-modulo-faq-tab]'));
    if (!tabs.length) return;
    var panels = Array.prototype.slice.call(el.querySelectorAll('[data-modulo-faq-panel]'));

    function selectTab(index, moveFocus) {
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
      });
      panels.forEach(function (panel, i) {
        var active = i === index;
        panel.classList.toggle('is-active', active);
        if (active) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      });
      if (moveFocus && tabs[index]) tabs[index].focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { selectTab(i, false); });
      tab.addEventListener('keydown', function (e) {
        // Both axes: the rail is vertical on desktop and a scroll row on mobile.
        var next = -1;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') next = (i + 1) % tabs.length;
        else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        if (next < 0) return;
        e.preventDefault();
        selectTab(next, true);
      });
    });
  }

  function bootstrap() {
    if (window.moduloLazyInit) {
      window.moduloLazyInit('[data-modulo-faq]', initSection);
    } else {
      var els = document.querySelectorAll('[data-modulo-faq]');
      for (var i = 0; i < els.length; i++) initSection(els[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  // Re-init in the theme editor. Without this a merchant who adds a Topic block
  // sees dead tabs until they reload. The dataset guard in initSection makes the
  // re-run safe; section:load hands us fresh DOM, so the guard is absent there.
  document.addEventListener('shopify:section:load', function (e) {
    var scope = e.target;
    if (!scope || !scope.querySelectorAll) return;
    var els = scope.querySelectorAll('[data-modulo-faq]');
    for (var i = 0; i < els.length; i++) initSection(els[i]);
    if (scope.matches && scope.matches('[data-modulo-faq]')) initSection(scope);
  });
})();
